<div class="mt-5 text-center">
    <p class="mb-0 text-muted">©
        <span>{{year}}</span> {{ environment.appName }}
    </p>
</div>
